export default __webpack_public_path__ + "static/media/yassir_preview.01358773.png";